export interface AppNotification {
  id: string;
  title: string;
  sub: string;
  time: string;
  icon: string;
  color: string;
  bg: string;
  /** Where tapping the alert takes the staff, when it leads somewhere. */
  onOpen?: () => void;
}

export interface NotificationPanelProps {
  open: boolean;
  isDesktop: boolean;
  notifications: AppNotification[];
  onClose: () => void;
  onDismiss: (id: string) => void;
  onClearAll: () => void;
}

/** Alerts (canvas v2-d-alerts): a panel beside the rail on tablets, under the header on phones. */
export function NotificationPanel({ open, isDesktop, notifications, onClose, onDismiss, onClearAll }: NotificationPanelProps) {
  if (!open) return null;
  return (
    <>
      <div className="pos-alerts-dim" onClick={onClose} />
      <aside aria-label="Alerts" className={`pos-alerts${isDesktop ? "" : " phone"}`}>
        <div className="pos-alerts-head">
          <h2>Alerts</h2>
          {notifications.length > 0 && <button onClick={onClearAll}>Clear all</button>}
          <button aria-label="Close alerts" onClick={onClose}>
            <span className="ms" aria-hidden="true" style={{ fontSize: 18 }}>
              close
            </span>
          </button>
        </div>
        {notifications.length === 0 ? (
          <div className="pos-alerts-empty">
            <span className="ms" aria-hidden="true">notifications_off</span>
            Nothing new. Ready orders and guest calls show up here.
          </div>
        ) : (
          <div className="pos-alerts-list">
            {notifications.map((n) => (
              <div key={n.id} className="pos-alert-item">
                <span style={{ background: n.bg, color: n.color }}>
                  <span className="ms" aria-hidden="true">{n.icon}</span>
                </span>
                <span role={n.onOpen ? "button" : undefined} tabIndex={n.onOpen ? 0 : undefined} style={n.onOpen ? { cursor: "pointer" } : undefined} onClick={n.onOpen} onKeyDown={(e) => e.key === "Enter" && n.onOpen?.()}>
                  <b>{n.title}</b>
                  <small>{n.sub}</small>
                </span>
                <span>{n.time}</span>
                <button aria-label={`Dismiss: ${n.title}`} onClick={() => onDismiss(n.id)}>
                  <span className="ms" aria-hidden="true" style={{ fontSize: 18 }}>
                    close
                  </span>
                </button>
              </div>
            ))}
          </div>
        )}
      </aside>
    </>
  );
}
